import { createInstance, setLogLevel } from '@optimizely/react-sdk';

import { getEnvironment } from '#src/lib/utils.mjs';
import { logger } from '#src/lib/logger';

// Set to 'debug' for troubleshooting
setLogLevel('warn');

const { GRAPHQL_URL, OPTIMIZELY_SDK_KEY } = getEnvironment();

// Optimizely SDK client as a singleton (module caching ensures this happens
// only once).
export const optimizelyClient = createInstance({
  sdkKey: OPTIMIZELY_SDK_KEY,
  datafileOptions: {
    autoUpdate: true,
    updateInterval: 60000, // 1 minute
    urlTemplate: buildUrlTemplate(),
  },
  // These are the defaults but set here to prevent SDK warnings
  eventBatchSize: 10,
  eventFlushInterval: 300,
  errorHandler: {
    handleError(error) {
      logger.error('Optimizely Client encountered an error', { error });
    },
  },
});

// Request the datafile file through graphql server to mitigate ad blocking.
// https://docs.developers.optimizely.com/full-stack/docs/initialize-sdk-reactnative#customize-datafile-management-behavior
function buildUrlTemplate() {
  try {
    return new URL('/optimizely/datafiles/%s.json', GRAPHQL_URL).toString();
  } catch (e) {
    // If an error occurs we'll return undefined here and Optimizely will fall
    // back to requesting the datafile from their CDN.
  }
}
